export default {
  faqHeading: 'Sign up for HireVibes as a:',
  faqTitle: 'FAQ',
  helloThere: 'Hello there'
}



// WEBPACK FOOTER //
// ./src/i18n/en/auth.js